import { render } from "./forbidden.vue?vue&type=template&id=d0481686"
const script = {}

import exportComponent from "C:\\Users\\Eduardo\\Documents\\RadSystems\\PHPRad Projects\\zendata\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__